import {
    RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew,
    RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage
} from "@src/assets/js/api.js"
var qsDetailDB={
    db:"",
    objectStore:"",
    options:{
        version:1
    },
    openDatabase (tableName) {
        return new Promise(resolve => {
            console.log(1111);
            console.log("qsDetailDB.options.version===>",qsDetailDB);
            var request = window.indexedDB.open("huidrQS",qsDetailDB.options.version);
            request.onerror=function (event) {
                console.log('数据库打开报错');
                resolve()
            }
            request.onsuccess = function (event) {
                qsDetailDB.db = request.result;
                qsDetailDB.options.version=qsDetailDB.options.version+1
                console.log('数据库打开成功',);
                resolve()
            };
            request.onupgradeneeded  = function(event) {
                qsDetailDB.db = event.target.result;
                if (!qsDetailDB.db.objectStoreNames.contains('qslist')) {
                    qsDetailDB.objectStore = qsDetailDB.db.createObjectStore('qslist', { keyPath: 'patientId' });
                }
                resolve()
            }
        })
    },
    addQsID:function (qs) {
        console.log("qs=========>",qs);
        // var request = qsDetailDB.db.transaction(['qslist'], 'readwrite')
        //     .objectStore('qslist')
        //     .add(qs);
        // request.onsuccess = function (event) {
        //     console.log('数据写入成功');
        // };
        // request.onerror = function (event) {
        //     console.log('数据写入失败',event);
        // }
    },
    listenerNextPage:function(p){
        // var result=qsDetailDB.db.transaction(['qslist'], 'readwrite')
        //     .objectStore('qslist')
        //     .get(p.patientId)
        //  result.onsuccess=function (e) {
        //     var qsDetail=e.target.result;
        //     if(!qsDetail.questionPageList[p.pageNumber-1] ){
        //         qsDetailDB.insertPageListById(p)
        //     }
        // }
    },
    insertPageListById:async function(p,callback){
        let request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew()
        // if(p.abnormal) {
        //    request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePageNew()
        // }else {
        //     request = new RestNewFollowupQuestionListServiceQueryPageAndQuestionListForOnePage()
        // }
        request.p_pageNumber = p.pageNumber
        request.p_questionnaireNewId = p.id || 227
        request.p_followupPatientId = p.patientId
        request.p_isQuestionnaireList = p.isQuestionnaireList
        request.p_followupPatientInfoId = p.followupPatientInfoId
        await  request.send()
        if(request.result.status==0){
            var errorQuestion=[]
            var questionList = request.result.retValue.map((item, index) => {
                var question = JSON.parse(JSON.stringify(qsDetailDB.questionHandle(item)))
                if(question.type==6){
                    errorQuestion.push(item)
                }
                return question
            })
            if(callback){
                callback({questionList:questionList,errorQuestion:errorQuestion})
            }
            // var store=qsDetailDB.db.transaction(['qslist'], 'readwrite')
            //     .objectStore('qslist')
            // var result=store.get(p.patientId)
            // result.onsuccess=function (e) {
            //     var qsDetail=e.target.result;
            //     if(qsDetail.questionPageList[p.pageNumber-1] && qsDetail.questionPageList[p.pageNumber-1].length==0 ){
            //         qsDetail.questionPageList[p.pageNumber-1]=questionList
            //         qsDetail.errorQuestion[p.pageNumber-1]=errorQuestion
            //         store.put(qsDetail)
            //     }else{
            //         qsDetail.questionPageList[p.pageNumber-1]=questionList
            //         qsDetail.errorQuestion[p.pageNumber-1]=errorQuestion
            //         store.put(qsDetail)
            //     }
            // }

        }

    },
    saveListpage:function(p){
        // var store=qsDetailDB.db.transaction(['qslist'], 'readwrite')
        //     .objectStore('qslist')
        // var result=store.get(p.patientId)
        // result.onsuccess=function (e) {
        //     var qsDetail=e.target.result;
        //     if(qsDetail.questionPageList[p.pageNumber-1] && qsDetail.questionPageList[p.pageNumber-1].length==0 ){
        //         qsDetail.questionPageList[p.pageNumber-1]=p.questionList
        //         store.put(qsDetail)
        //     }else{
        //         qsDetail.questionPageList[p.pageNumber-1]=p.questionList
        //         store.put(qsDetail)
        //     }
        // }
    },
    getPageListById:function(p,callback){
        qsDetailDB.insertPageListById(p,(source)=>{
            callback(source)
        })
        // var store=qsDetailDB.db.transaction(['qslist'], 'readwrite')
        //     .objectStore('qslist')
        // var result=store.get(p.patientId)
        // result.onsuccess=function (e) {
        //     console.log('onSuccess');
        //     var qsDetail=e.target.result;
        //     console.log('qsDetail',qsDetail);
        //     if(qsDetail.questionPageList[p.pageNumber-1]){
        //         callback({
        //             questionList:qsDetail.questionPageList[p.pageNumber-1],
        //             errorQuestion:qsDetail.errorQuestion[p.pageNumber-1]
        //         })
        //     }else{
        //         qsDetailDB.insertPageListById(p,(source)=>{
        //             callback(source)
        //         })
        //     }
        //
        // }
        // result.onerror = (e) => {
        //     console.log('error',e);
        // }
    },
    read:function () {
        // console.log(JSON.stringify(qsDetailDB.db));
        // var transaction = qsDetailDB.db.transaction(['qslist']);
        // var objectStore = transaction.objectStore('qslist');
        // var request = objectStore.get(1);
        //
        // request.onerror = function(event) {
        //     console.log('事务失败');
        // };
        // request.onsuccess = function( event) {
        //     if (request.result) {
        //
        //     } else {
        //         console.log('未获得数据记录');
        //     }
        // };
    },
    questionHandle:function (question) {
        if (question.type) {
            question.completeConfig = question.completeConfig == '' ? {
                'completeTextArr': [{'text1': '', 'text2': ''}],
                'completeType': 'text',
                'maxLength': null
            } : JSON.parse(question.completeConfig)
            question.bingTimeId =question.bingTimeId ? JSON.parse(question.bingTimeId) : null
            question.showQualityResult = false
            question.timeConfigArr =question.timeConfigArr ? JSON.parse(question.timeConfigArr) : [{type: '',withBingId: '',value: ''}]
            question.displayConfig = question.displayConfig == '' ? {'displaySettingArr': []} : JSON.parse(question.displayConfig)
            question.jumpConfig = question.jumpConfig == '' ? {'jumpSettingArr': []} : JSON.parse(question.jumpConfig)
            question.displayNumber = question.displayNumber == '' ? [] : JSON.parse(question.displayNumber)
            question.scaleConfig = question.scaleConfig == '' ? [] : JSON.parse(question.scaleConfig)
            question.jumpNumber = question.jumpNumber == '' ? [] : JSON.parse(question.jumpNumber)
            question.dateCycle = qsDetailDB.getBoolean(question.dateCycle)
            question.isFirst = qsDetailDB.getBoolean(question.isFirst)
            question.isMust = qsDetailDB.getBoolean(question.isMust)
            question.isShow = qsDetailDB.getBoolean(question.isShow)
            question.manangerActive = qsDetailDB.getBoolean(question.manangerActive)
            question.seqDisabled = qsDetailDB.getBoolean(question.seqDisabled)
            question.paragraphConfig = question.paragraphConfig == '' ? "" : JSON.parse(question.paragraphConfig)
            question.manangerActive = false
            // question.answerQualityControlInfo = question.answerQualityControlInfo ? (question.answerQualityControlInfo.id ? question.answerQualityControlInfo : {isRight: 1}) : {}
            if (question.answerInfo) {
                if (qsDetailDB.isJSON(question.answerInfo,question)) {
                    question.value = JSON.parse(question.answerInfo)
                } else {
                    question.value = question.answerInfo
                }
            } else {
                question.value = ''
            }
            // 批注
            question.answerQcInfoRemark=""
            question.errorAnswerQcInfo=[]
            if (question.answerQualityControlInfo) {
              question.errorAnswerQcInfo = question.answerQualityControlInfo.filter(item=> item.isRight==false)
              question.answerQualityControlInfo.forEach(pre=>{
                question.answerQcInfoRemark += pre.remark?`${pre.remark}；`: ''
              })
              if (question.answerQcInfoRemark!='') {
                question.answerQcInfoRemark=question.answerQcInfoRemark.substring(0, question.answerQcInfoRemark.length - 1);
              }
            }
            
            question.errorAnswerQcInfo.length>0?question.isRightAnd=false:question.isRightAnd=true
            question.options = question.optionsInfoRespList
        }
        return question
    },
    getBoolean:function(num) {
        return num == 1 ? false : true
    },
    isJSON:function(str,question) {
        if (typeof str == 'string') {
            try {
                var obj = JSON.parse(str)
                if (typeof obj == 'object' && obj) {
                    return true
                } else {
                    return false
                }
            } catch (e) {
                console.log('error：' + str + '!!!' + e)
                return false
            }
        }
    },

}
export default qsDetailDB